
<section class="ui_actionbar" ref="actionbar">
  <div class="actionbar">
    <ul class="actionbar_list">
      <li class="actionbar_each GTMClass_preventPointerEvent" @click="onClick(icon)" :id="icon.gtmId ?  'GTM'+ icon.gtmId : icon.name" @mouseover="showEx($event,index,true,icon)" 
      @mouseleave="showEx($event,index,false,icon)" v-for="(icon,index) in iconList" :class="{'disabled':icon.disabled}" 
      :tabindex="icon.disabled ? -1 : 0" @keypress.enter="onClick(icon)">
        <div class="actionbar_icon">
          <!-- <img :src="getImgUrl(icon.name)" > -->
          <iCon :iconClass="icon.name" class=" actionbar_svg" ></iCon>
        </div>
        <!-- <div class="tooltips">{{icon.val}}</div> -->
      </li>
    </ul>
  </div>
  <div class="tooltips"  v-for="(item, index) in iconList"  
  :class="[detail && (detail.val ==  item.val) ? 'show':'noshow']" :style="itemClass">
      <!-- <div>{{detail}}</div> -->
      <div>{{itemName}}</div>
  </div>
</section>

